import { render } from "./CampoAdicionarDiminuirNumero.vue?vue&type=template&id=0b3e71fe&scoped=true&ts=true"
import script from "./CampoAdicionarDiminuirNumero.vue?vue&type=script&lang=ts"
export * from "./CampoAdicionarDiminuirNumero.vue?vue&type=script&lang=ts"

import "./CampoAdicionarDiminuirNumero.vue?vue&type=style&index=0&id=0b3e71fe&scoped=true&lang=css"

import exportComponent from "D:\\UniParking\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3e71fe"]])

export default __exports__